import { FC, useCallback, useEffect, useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { MyBookingsProps } from './types';
import { myOrderStyled as styled } from './styled';
import { Image } from '../../components/Image';
import { Text } from '../../components/Text';
import { STYLE_VARS } from '../../constants/style-vars';
import { Footer } from '../../components/Footer';
import OrderCollapse from './Components/OrderCollapse';
import { DumpOrders } from './constants';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import MyAccountLayout from '../../components/MyAccountLayout/MyAccountLayout';
import PageTitle from '../../components/PageTitle';
import { wooCommerceApi } from '../../services/api/wooCommerceApi';
import { Order } from '../../types/woocommerce.types';
import { Loading } from '../../components';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { COLORS, FONTS } from '../../constants';
import { NavigationService } from '../../services/navigation';

const MyOrders: FC<MyBookingsProps> = ({ navigation }) => {
  const isDesktop = useIsDesktop();
  const [orders, setOrders] = useState<Order[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { info } = useSelector((redux: RootState) => redux.authReducer);

  const getOrders = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await wooCommerceApi.get('orders', {
        per_page: 20,
        customer: info?.ID,
        orderby: 'date',
      });
      setOrders(res.data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [info?.ID]);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      getOrders();
    });

    return unsubscribe;
  }, [getOrders, navigation]);

  if (isDesktop()) {
    return (
      <MyAccountLayout
        title="My orders"
        current={3}
        icon={require('../../assets/orders-white.png')}
      >
        <View
          style={{
            flexDirection: 'row',
            paddingHorizontal: 20,
            paddingVertical: 15,
            backgroundColor: STYLE_VARS.kccBgGreen,
            justifyContent: 'space-between',
          }}
        >
          <Text
            style={[
              styled.headerText,
              {
                width: '20%',
                paddingLeft: 30,
                paddingRight: 10,
              },
            ]}
          >
            Date
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                width: '30%',
                paddingRight: 10,
              },
            ]}
          >
            Order#
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                width: '30%',
                paddingHorizontal: 10,
              },
            ]}
          >
            Total
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                width: '20%',
              },
            ]}
          >
            Status
          </Text>
        </View>
        <View>
          {isLoading ? (
            <View style={{ marginTop: 20 }}>
              <Loading />
            </View>
          ) : (
            <View>
              {orders.length > 0 ? (
                orders.map((order) => (
                  <OrderCollapse
                    key={order.id}
                    orderDetails={order}
                    onCancel={() => {
                      getOrders();
                    }}
                  />
                ))
              ) : (
                <Text
                  style={{
                    color: COLORS.GREEN,
                    fontSize: 18,
                    fontFamily: FONTS.IowanOldStyleBTRoman,
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    marginTop: 20,
                  }}
                >
                  THERE ARE CURRENTLY NO ORDERS
                </Text>
              )}
            </View>
          )}
        </View>
      </MyAccountLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styled.container}>
        <PageTitle
          title="My Orders"
          icon={require('../../assets/orders-white.png')}
          haveGoBackButton={true}
          handleGoBack={() => {
            NavigationService.push('Root', {
              screen: 'MyAccountTab',
            });
          }}
        />
      </View>
      <View
        style={{
          marginBottom: 50,
          zIndex: 1,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            paddingHorizontal: 20,
            paddingVertical: 15,
            backgroundColor: STYLE_VARS.kccBgGreen,
            justifyContent: 'space-between',
          }}
        >
          <Text
            style={[
              styled.headerText,
              {
                width: '25%',
              },
            ]}
          >
            Date
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                alignItems: 'flex-start',
                paddingRight: 20,
              },
            ]}
          >
            Order#
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                alignItems: 'flex-start',
              },
            ]}
          >
            Total
          </Text>
          <Text
            style={[
              styled.headerText,
              {
                width: '30%',
                textAlign: 'right',
              },
            ]}
          >
            Status
          </Text>
        </View>
        <View>
          {isLoading ? (
            <View style={{ marginTop: 20 }}>
              <Loading />
            </View>
          ) : (
            <View>
              {orders.length > 0 ? (
                orders.map((order) => (
                  <OrderCollapse
                    key={order.id}
                    orderDetails={order}
                    onCancel={() => {
                      getOrders();
                    }}
                  />
                ))
              ) : (
                <Text
                  style={{
                    color: COLORS.GREEN,
                    fontSize: 16,
                    fontFamily: FONTS.IowanOldStyleBTRoman,
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    marginTop: 20,
                  }}
                >
                  THERE ARE CURRENTLY NO ORDERS
                </Text>
              )}
            </View>
          )}
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default MyOrders;
